import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <main className="min-h-[70vh] flex items-center justify-center px-6 py-16">
            <div className="text-center max-w-xl bg-white/80 backdrop-blur-lg border border-white/40 shadow-xl rounded-3xl p-10 space-y-6">
                <p className="text-7xl font-bold text-primary/20 tracking-tight">404</p>
                <div className="space-y-3">
                    <h1 className="text-3xl font-semibold text-gray-900">
                        Page Not Found
                    </h1>
                    <p className="text-gray-600">
                        The page you are looking for doesn’t exist or may have been moved.
                        Let’s get you back to a safe place.
                    </p>
                </div>
                <Link
                    to="/"
                    className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-primary text-white font-medium shadow-lg shadow-primary/30 hover:-translate-y-0.5 hover:shadow-xl transition-transform duration-200"
                >
                    Back to Home
                </Link>
            </div>
        </main>
    );
};

export default NotFound;

